import React, { FC, ReactNode } from "react";

import TextField from "@stadium/ui/src/components/form/TextInput";

import ErrorMsg from "@stadium/ui/src/components/error-message/error-message";
import { EventArgs } from "@stadium/ui/types/form-text-input";

import styles from "./main.module.scss";

type RangeType = "min" | "max";
type RangeTextInputProps = {
  minValue: { value: string; error?: string };
  maxValue: { value: string; error?: string };
  suffix?: ReactNode;
  validator?: (options: EventArgs) => EventArgs;
  autoFocus?: boolean;
  onChange: (type: RangeType, e: EventArgs) => void;
  minValPlaceHolder?: string;
  maxValPlaceHolder?: string;
  rowClass?: string;
  inputClass?: string;
};

const RangeTextInput: FC<RangeTextInputProps> = ({
  minValue,
  maxValue,
  suffix,
  validator,
  autoFocus,
  onChange,
  rowClass,
  inputClass,
  minValPlaceHolder = "1",
  maxValPlaceHolder = "100",
}) => (
  <div className={`${styles.inputRow} ${rowClass}`}>
    <div className={styles.inputCol}>
      <TextField
        id="minValue"
        value={minValue.value}
        placeholder={minValPlaceHolder}
        onChange={(e) => onChange("min", e)}
        error={!!minValue?.error}
        suffix={suffix}
        autoFocus={autoFocus}
        validate={validator}
        name="minValue"
        className={`${styles.inputField} ${inputClass}`}
        type="number"
        inputMode="numeric"
      />

      <ErrorMsg msg={minValue?.error} />
    </div>

    <div className={styles.inputColBetween}>TO</div>

    <div className={styles.inputCol}>
      <TextField
        id="maxValue"
        value={maxValue.value}
        placeholder={maxValPlaceHolder}
        onChange={(e) => onChange("max", e)}
        error={!!maxValue?.error}
        suffix={suffix}
        validate={validator}
        name="maxValue"
        className={`${styles.inputField} ${inputClass}`}
        type="number"
        inputMode="numeric"
      />
      <ErrorMsg msg={maxValue?.error} />
    </div>
  </div>
);
export default RangeTextInput;
